import {Device} from '../../constants';
import styled from 'styled-components';

export default styled.div`
  p {
    margin-bottom: 2em;
    &.centered {
      text-align: center;
    }
  }
  .buttonContainer {
    text-align: center;
  }
  .btn {
    @media screen and ${Device.mobileL} {
      width: 100% !important;
      margin-bottom: 2em;
    }
  }
`;
